import { SiteDTO, SiteType } from '@luminovo/api-contracts';
import { Flexbox, Tag, TagProps } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import { CSSProperties } from 'react';

import { hasSiteTag } from '../../extractors';
import { siteTypeTranslations } from '../../i18n';

const SiteTypeTag = ({
    siteType,
    color,
    style,
}: {
    siteType: SiteType;
    color: TagProps['color'];
    style?: CSSProperties;
}): JSX.Element => {
    return <Tag attention="low" label={transEnum(siteType, siteTypeTranslations)} color={color} style={style} />;
};

export const ManufacturingTag = ({ style }: { style?: CSSProperties }): JSX.Element => {
    return <SiteTypeTag siteType={'Manufacturing'} color="teal" style={style} />;
};

export const InventoryTag = ({ style }: { style?: CSSProperties }): JSX.Element => {
    return <SiteTypeTag siteType={'Inventory'} color="primary" style={style} />;
};

export const SourcingTag = ({ style }: { style?: CSSProperties }): JSX.Element => {
    return <SiteTypeTag siteType={'Sourcing'} color="green" style={style} />;
};

export const SiteTagsLabel = ({ site, style }: { site: Pick<SiteDTO, 'tags'>; style?: CSSProperties }): JSX.Element => {
    return (
        <Flexbox gap={4}>
            {hasSiteTag(site, 'Manufacturing') && <ManufacturingTag style={style} />}
            {hasSiteTag(site, 'Inventory') && <InventoryTag style={style} />}
            {hasSiteTag(site, 'Sourcing') && <SourcingTag style={style} />}
        </Flexbox>
    );
};
